export default class AnalyticsManager {
  static mixpanelInstance
}
